module.exports = __webpack_public_path__ + "img/Vermutete_Gefahr_durch_gefährliche_Stoffe.70018fbd.svg";